/**
 * RecommendationsCard — recomendaciones lazy del adapter del motor.
 *
 * Decisión técnica 5 Bloque 4: el frontend solo formatea — el copy del
 * `message` viene del backend (i18n no aplica porque el message ya está
 * en español, generado por adapter.py / endpoint).
 *
 * Render compacto arriba del plan. Si recommendations vacío, NO renderiza
 * nada (el caller decide; este componente asume que se le pasa una lista
 * con al menos 1 entrada).
 */
import { t } from "@/i18n/es";
import type { TrainingRecommendation } from "@/types/api";

export interface RecommendationsCardProps {
  recommendations: TrainingRecommendation[];
}

export function RecommendationsCard({ recommendations }: RecommendationsCardProps) {
  if (recommendations.length === 0) return null;

  return (
    <section
      data-testid="recommendations-card"
      aria-label={t.plan.recommendationsTitle}
      className="rounded-lg border border-warning/30 bg-warning/10 p-4"
    >
      <h3 className="mb-2 text-xs font-medium uppercase tracking-widest text-warning">
        {t.plan.recommendationsTitle}
      </h3>
      <ul className="flex flex-col gap-2">
        {recommendations.map((rec, idx) => (
          <li
            key={`${rec.type}-${idx}`}
            data-testid={`recommendation-${rec.type}`}
            className="text-sm text-bone"
          >
            {rec.message}
          </li>
        ))}
      </ul>
    </section>
  );
}
